export const SET_NAME = "setName";
export const SET_ROLE = "setRole";
